import ManualLayout from './ManualLayout';

export default ManualLayout;
